<template>
    <div class="questionItem_body">
        <div class="item">
            <div class="item-top">
                <div class="item-top-1">
                    <p>{{bookItemObj.regionFullName}}</p>
                </div>
                <popDrop class="item-top-2"  border="1rem solid #999999" @option="option" width="82rem" height="32rem" fontsize="14rem" top="2rem" left="11rem" dropdownText1="编辑地区" dropdownText2="禁用地区" dropdownText3="删除地区"></popDrop>
                <el-button icon="el-icon-circle-plus-outline" plain size="mini " class="item-top-3" @click="showNewQuestionDia">新增题源</el-button> 
            </div>
            <div class="item-middle">
                <bookItem v-for="(item, index) in books" 
                :book=item
                :gradeList="gradeList"
                :versionList="versionList"
                 v-bind="$attrs"
                :key="index"
                :regionFullName="bookItemObj.regionFullName"
                :_refreshFlag=refreshFlag
                :pageIndex=pageParams.pageNum
                @enableBook=enableBook($event,item)
                @enableCatalog=enableCatalog
                @deleteBook=deleteBook
                @newOrUpdateQuestion=newOrUpdateQuestion
                @refreshFlagToFalse=refreshFlagToFalse
                ref="child"
                class="item-middle-1">
                </bookItem>
            </div>
            <div class="item-bottom" v-if="bottomShow">
                <el-pagination
                :total="totle"
                :page-size="pageParams.pageSize"
                :current-page.sync="pageParams.pageNum"
                :background="true"
                @current-change="getBookInfo"
                layout="prev, slot, next"
                prev-text="< 上一页 "
                next-text="下一页 >"                                                           
                 >
                    <span><b>{{pageParams.pageNum}}</b>/{{totalPage}}</span>
                </el-pagination>
            </div>
        </div>

        <!-- 遮罩层 -->
        <div class="mask" v-if="bookItemObj.status=='0'?false:true">
            <el-button @click="enableDistrict">启用地区</el-button>
            <img class="image" src="../static/forbidden.png">
        </div>
        <el-empty description=" " :image-size="200" :image="require('../static/empty.png')" v-if="empty"></el-empty>
        <newQuestionDia 
        :dialogVisible="newQuestionVisible"
        v-bind="$attrs"
        :title="title"
        :gradeList="gradeList"
        :versionList="versionList"
        @newOrUpdateQuestion="newOrUpdateQuestion"
        @dialogClose="dialogClose"
        ></newQuestionDia>
    </div>
</template>
<script>
import bookItem from './book'
import popDrop from './popdrop'
import newQuestionDia from './newQuestionDia'
import {updateBookStatus, updateCatalogStatus, addOrEditQuestion, deleteBook} from '@/api/questionIndex'
export default {
    name: 'questionItem',
    components: {
        bookItem,
        popDrop,
        newQuestionDia
    },
    props: {
        bookItemObj:{
            type: Object,
            default: () => {}
        },
        refreshFlag:{
            type:Boolean,
            default:false
        },
        gradeList: Array,
        versionList: Array,
    },
    watch:{
        bookItemObj:{   
            handler(newVal){
                this.totle = newVal.bookTypeList.length
                if(!this.totle){
                    this.bottomShow = false;
                }else{
                    this.bottomShow = true;
                }
                if(newVal.bookTypeList.length == 0){
                    this.empty = true;
                }else{
                    this.empty = false;
                }                    
            },
            deep: true,
            immediate:true
        },
        //refreshFlag标志刷新数据
        refreshFlag:{
            handler(newVal){
                //等待页面加载完成 不然会丢失数据
                this.$nextTick(() => {
                    if(newVal){ 
                        this.books = this.bookItemObj.bookTypeList.slice((this.pageParams.pageNum-1)*this.pageParams.pageSize, this.pageParams.pageNum*this.pageParams.pageSize)
                        if(this.books.length == 0){
                            this.$emit('refreshFlagToFalse')
                        }
                    }   
                })

            },
            immediate:true
        },
        pageParams:{
            //手动分页
            handler(newVal){
                if(this.bookItemObj.bookTypeList.length > 0){
                    this.pageParams.pageNum = newVal.pageNum
                    this.books = this.bookItemObj.bookTypeList.slice((newVal.pageNum-1)*newVal.pageSize, newVal.pageNum*newVal.pageSize)
                }
            },
            deep: true,
            immediate:true
        },
        
    },
    computed: {
        totalPage(){
            return Math.ceil(this.totle/this.pageParams.pageSize)
        }
    },

    data() {
        return {
            empty:false,
            totle:10,
            bottomShow:true,
            newQuestionVisible:false,
            areaIdNodes:[],
            books:[],
            title:'',
            pageParams:{
                pageSize: 2,
                pageNum: 1
            },
        }
    },
    methods: {
        option(command){
            if(command == '1'){
                this.$emit('editDistrict', this.bookItemObj)
            }
            if(command == '2'){
                 this.$confirm('禁用后，将关闭该地区下题源、模块等各级启用权限', '是否禁用当前地区?', {
                distinguishCancelAndClose: true,
                confirmButtonText: '禁用',
                cancelButtonText: '取消',
                customClass:"customClass_1",
                confirmButtonClass: "btnConfirm",
                cancelButtonClass:'btnCancel'
                }).then(()=>{ 
                    this.$emit('enableDistrict', '1')
                }).catch(()=>{})
            }
            if(command == '3'){
                console.log(this.bookItemObj)
                // return;
                this.$confirm('删除后，数据将被清除无法恢复', '是否删除当前地区？', {
                distinguishCancelAndClose: true,
                confirmButtonText: '删除',
                cancelButtonText: '取消',
                customClass:"customClass",
                confirmButtonClass: "btnConfirm",
                cancelButtonClass:'btnCancel'
                }).then(()=>{
                    this.$emit('delRegion',this.bookItemObj)
                }).catch(()=>{
                })
            }
        },
        getBookInfo(){
            // console.log(e)
        },
        dialogClose(){
            this.newQuestionVisible = false;
        },

        //启用/禁用地区
        enableDistrict(){
            this.$confirm('启用后，还需打开该地区下题源、模块等各级启用权限', '是否启用当前地区？', {
            distinguishCancelAndClose: true,
            confirmButtonText: '启用',
            cancelButtonText: '取消',
            customClass:"customClass_1",
            confirmButtonClass: "btnConfirm",
            cancelButtonClass:'btnCancel'
            }).then(()=>{
                this.$emit('enableDistrict', '0')
            }).catch(()=>{})
        },
        //启用/禁用题源
        enableBook(e,item){
            let word = e=='0'?'启用成功':'禁用成功'
            updateBookStatus({regionId:this.bookItemObj.id, bookTypeId:item.bookTypeId, status:e}).then(res => {
                if(res.code == 0){
                    this.$message.success(word)
                    this.$emit('initData')

                    
                }else{
                    this.$message.error(res.info)
                }
            })
        },
        //启用/禁用模块
        enableCatalog(e){
            let word = e.status=='1'?'启用成功':'禁用成功'
            let status = e.status=='0'? '1':'0'
            updateCatalogStatus({bookId:e.bookId, type:e.type, status:status}).then(res => {
            if(res.code == 0){
                this.$message.success(word)
                this.$emit('initData')
                
            }else{
                this.$message.error(res.info)
            }
            })
        },
        //删除题源
        deleteBook(item){
            deleteBook({bookId:item.id}).then(res => {
                if(res.code == 0){
                    this.$message.success('删除题源成功')
                    this.$emit('initData')
                }else{
                    this.$message.error(res.info)
                }
            })
        },
        showNewQuestionDia(){
            this.newQuestionVisible = true;
            this.title = `新增题源（${this.bookItemObj.regionFullName}）`
        },
        //新增、编辑题源
        newOrUpdateQuestion(e){
            //深拷贝子组件传递过来的对象数据，使用新对象进行数据转换 不影响原数据
            let dataObj = {...e}
            dataObj.regionId = this.bookItemObj.id
            dataObj.status = dataObj.status==true?'0':'1'
            dataObj.bookTypeId = dataObj.bookTypeId[dataObj.bookTypeId.length-1]
            // console.log(e)
            let word = dataObj.id?"修改成功":"新增成功"
            addOrEditQuestion(dataObj).then(res =>{
                if(res.code == 0){
                    this.$message.success(word)
                    this.$emit('initData')
                    //刷新轮播图
                }else{
                    this.$message.error(res.info)
                }
            })
        },
        refreshFlagToFalse(){
            this.$emit('refreshFlagToFalse')
        },
    }
}
</script>

<style lang="scss" scoped>
    .questionItem_body{ 
        position: relative;
        width: 805rem;
        height: 553rem;
        background: #f5f5f5;
        border-radius: 12rem;
        .item{  
            height: 100%; 
            width: 100%;                
            display: flex;
            flex-direction: column;
            display: flex;
            .item-top{
                display: flex;
                align-items: center;
                height: 45rem;
                margin-top:20rem;
                z-index: 10;
                .item-top-1{
                    width: 180rem; 
                    height: 48rem;
                    border-top-right-radius: 22.5rem; 
                    border-bottom-right-radius: 22.5rem; 
                    background-image: var(--background-image);
                    p{
                        margin: 0rem;
                        white-space: nowrap;
                        overflow: hidden;
                        line-height: 44rem;
                        height: 48rem;
                        margin-left: 30%;
                        color: #FFF;
                        font-size: 20rem;
                    }
                    p::before{
                        content: "";
                        width: 32rem;
                        height: 32rem;
                        background: url('../static/locate.png') center no-repeat;
                        position: absolute;
                        left: 2%;
                        top: 26rem;
                    }
                }
                .bottom-1{
                    
                    position: absolute;
                    right: 150rem;
                }
                .item-top-3{
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    position: absolute;
                    width: 110rem;
                    height: 32rem;
                    right: 25rem;
                    color: var(--primary-color);
                    border-color:var(--primary-color);
                    font-size: 14rem;
                }
            }
            .item-middle{
                padding: 20rem;
                height: 400rem;
                display: flex;
                flex-wrap: wrap;
                justify-content: space-around;
                .item-middle-1{
                   
                }
                
            }
            .item-bottom{
                margin: 0rem auto;
                padding-bottom: 20rem;
                z-index:10;
                span{
                    margin-left: 16rem;
                    b{
                        color: var(--primary-color);
                    }
                }
            }

        }
        .mask {
            position: absolute;
            border-radius: 10rem;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, 0.5);
            /* 按钮居中 */
            display: flex;
            justify-content: center;
            align-items: center; 
            z-index: 50;
            .el-button{
                color: #FFF;
                background-image:var(--background-image);
                border: none !important;
                border-radius: 6rem;
                box-shadow: none !important;
                font-size: 22rem;
                width: 136rem;
                height: 58rem;
            }
            .image{
                width: 120rem;
                height: 120rem;
                position: absolute;
                top: -28rem;
                right: -28rem;
            }
        }
        .el-empty {
            position: absolute;
            border-radius: 10rem;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            z-index: 0;
        }

    }
    ::v-deep .el-icon-ellipsis{
        position: relative;
        top: 1rem;
        background: url('../static/ellipsis.png') center no-repeat;
        width: 14rem;
        height: 14rem;
    }

</style>
<style lang='scss'>
    .customClass_1{
        width:460rem;
        border-radius: 8rem;
        box-sizing: border-box;
        .el-message-box__header .el-message-box__title span{
            margin-left: 20rem;
            &::before{
                content:url(../static/warning.png); 
             
                position: relative;
                top:5rem;
                left: -15rem;
            }
        }
        .el-message-box__headerbtn .el-message-box__close{
            transform: scale(1.4,1.4);
            margin-top: 10rem;
        }
        .el-message-box__headerbtn .el-message-box__close:hover{
            color: var(--primary-color);
        }
        .el-message-box__title{
            font-size: 18rem;
            color: #000000;
            font-weight:bold;
            height: 30rem;
            span{
                position: absolute;
                top: 12rem;
            }
        }
        .el-message-box__content{
            font-size: 14rem;
            height: 24rem;
            p{
                margin-left: 48rem;
                position: absolute;
                top: -5rem;
            }
        }
    }

</style>